/**
 * JWT auth helpers — token is persisted in localStorage under 'cs-jwt'.
 * Used by api.ts (Authorization header + 401 redirect) and the route guard.
 */

const TOKEN_KEY = 'cs-jwt'

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch {
    // localStorage may be unavailable (private mode / SSR) — fail silently.
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch {
    // see setToken
  }
}

export function isLoggedIn(): boolean {
  return getToken() !== null
}
